import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const pageHeaderFn = /* @__PURE__ */ createRecipe('mars-page-header', {
  "behavior": "default"
}, [])

const pageHeaderVariantMap = {
  "behavior": [
    "default",
    "withBack"
  ]
}

const pageHeaderVariantKeys = Object.keys(pageHeaderVariantMap)

export const pageHeader = /* @__PURE__ */ Object.assign(memo(pageHeaderFn), {
  __recipe__: true,
  __name__: 'pageHeader',
  raw: (props) => props,
  variantKeys: pageHeaderVariantKeys,
  variantMap: pageHeaderVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, pageHeaderVariantKeys)
  },
})